import { render, staticRenderFns } from "./DeliveryDetailCard.vue?vue&type=template&id=019bfe0a&scoped=true&"
import script from "./DeliveryDetailCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailCard.vue?vue&type=style&index=0&id=019bfe0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bfe0a",
  null
  
)

export default component.exports